var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitorsIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 6C11.1046 6 12 5.10457 12 4C12 2.89543 11.1046 2 10 2C8.89543 2 8 2.89543 8 4C8 5.10457 8.89543 6 10 6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.6666 13.334C12.5075 13.334 13.9999 12.4386 13.9999 11.334C13.9999 10.2294 12.5075 9.33398 10.6666 9.33398C8.82564 9.33398 7.33325 10.2294 7.33325 11.334C7.33325 12.4386 8.82564 13.334 10.6666 13.334Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 6.66732C7.47341 6.66732 8.66732 5.47341 8.66732 4.00065C8.66732 2.52789 7.47341 1.33398 6.00065 1.33398C4.52789 1.33398 3.33398 2.52789 3.33398 4.00065C3.33398 5.47341 4.52789 6.66732 6.00065 6.66732Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 14.0013C8.57798 14.0013 10.6673 12.8074 10.6673 11.3346C10.6673 9.86188 8.57798 8.66797 6.00065 8.66797C3.42332 8.66797 1.33398 9.86188 1.33398 11.3346C1.33398 12.8074 3.42332 14.0013 6.00065 14.0013Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorsIconWhite);
export default __webpack_public_path__ + "static/media/visitors-icon-white.b6eb9c2caa4f1427b62cf1d5acf3b786.svg";
export { ForwardRef as ReactComponent };